import { type ReactElement, type ReactNode, useEffect } from 'react';
import { useDeviceType } from '@cars4ever/public-ui';

import { autoCalculateSpacers } from '^utils/widgetActions';

import styles from './styles.module.scss';

export interface IWidgetLayoutProviderProps {
  children: ReactNode;
}

const WidgetLayoutProvider = ({ children }: IWidgetLayoutProviderProps): ReactElement => {
  const { isDesktop } = useDeviceType();

  useEffect(
    (): (() => void) | void => {
      if (window.xprops.isWidgetMode) {
        document.documentElement.classList.add(styles.widgetLayout);
      }

      if (isDesktop) {
        return;
      }

      void autoCalculateSpacers();
    },
    [isDesktop],
  );

  return children as ReactElement; // Update if https://github.com/yannickcr/eslint-plugin-react/pull/2967 is merged
};

export default WidgetLayoutProvider;
